export default {
    header: 'Add Special workday',
    headerEdit: 'Edit Special workday',
    specialWorkdayName: 'Special Workday Name',
    enterSpecialWorkdayName: 'Enter Special Workday Name',
    bureau: 'Bureau',
    selectBureau: '- Select Bureau -',
    workDate: 'Work date',
    checkInTime: 'Check in Time',
    startTime: 'Start Time',
    lateCheckIn: 'Late Check in',
    lastCheckIn: 'Last Check in',
    breakHours: 'Break hours',
    endTime: 'End Time',
    save: 'save',
    require: 'this field is required.',
    requireBureau: 'Please select bureau',
    checkInTimeLessThanStartTime: 'Check in time must be less than start time.',
    startTimeLessThanLateCheckIn: 'Start in time must be less than check in time.',
    lateCheckInLessThanLastCheckIn: 'Late check in time must be less than last check in time.',
    lastCheckInLessThanEndTime: 'Last check in time must be less than end time.',
    endTimeMoreThanLastCheckIn: 'End time must be more than last check in time.',
    congratulation: 'Congratulation',
    created: 'Special workday was created.',
    updated: 'Special workday was edited.',
    errorTitle: 'Something went wrong'
}
